import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import useOwnedCarbonTokens from 'src/common/apollo/hooks/useOwnedCarbonTokens'
import { useAllTokensForOwner } from 'src/common/queries/useTokensForOwner/useAllTokensForOwner'
import { big } from 'src/common/utils/big-utils'
import { aggregateNFTCollection } from 'src/common/utils/collections/aggregateNFTBalances'

export const useOwnedTokens = () => {
  const { smartAccountInfo } = useSmartAccount()
  const { ownedErc20s, isLoading: ownedErc20sLoading } = useAllTokensForOwner(
    smartAccountInfo?.address || ''
  )

  const {
    ownedCarbonTokens,
    total,
    loading: ownedCarbonLoading,
  } = useOwnedCarbonTokens(smartAccountInfo?.address)

  const firstCarbonNft = aggregateNFTCollection(ownedCarbonTokens)[0]
  if (firstCarbonNft && total) {
    firstCarbonNft.balance = big(total)
  }

  const ownedTokens = firstCarbonNft
    ? [...ownedErc20s, firstCarbonNft]
    : ownedErc20s

  return {
    ownedTokens,
    loading: ownedErc20sLoading || ownedCarbonLoading,
  }
}
